import * as React from 'react';

import './ExercisesContainer.scss';

import ENV from '../../base/env';

export interface IExercisesContainerProps {
  // optional icon
  icon?: string;
  // optional title
  title?: string;
  // optional tag badge
  tag?: string;
  // optional hint
  hint?: React.ReactElement;
  // custom container class name
  className?: string;
  // skeleton (loading state) class name
  skeletonClass?: string;
}

const ExercisesContainer: React.FC<React.PropsWithChildren<IExercisesContainerProps>> = ({
  icon = '',
  title = '',
  tag,
  hint = null,
  className = '',
  skeletonClass = '',
  children,
}) => {
  let header = (
    <h2 className="exercises-container-title">
      {title}
      {hint}
    </h2>
  );
  if (!!icon || !!tag) {
    const iconSrc = `${ENV.AssetsBaseUrl}/${icon}`;
    header = (
      <p>
        <img className="exercises-container-icon" src={iconSrc} alt={title} />
        <span className="exercises-container-title">{title}</span>
        {tag ? <span className="exercises-container-tag">{tag}</span> : null}
        {hint}
      </p>
    );
  }
  return (
    <div className={`exercises-container ${className}`}>
      <div className={`exercises-container-header ${skeletonClass}`}>{header}</div>
      <div className="row exercises-container-body">{children}</div>
    </div>
  );
};

export default ExercisesContainer;
